import React from "react";
import TextField from "@/components/common/text-field";
import ipapi from "ipapi.co";
import { Controller } from "react-hook-form";
import { m } from "framer-motion";
import { getCode } from "country-list";
import PhoneInput from "../common/phone-input";
import { Listbox, RadioGroup, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";
import { defaultClasses } from "@/components/common/text-field";
import MultiCountryField from "../common/multi-country-field";
import { isValidPhoneNumber } from "react-phone-number-input";

const validateEmail = require("email-validator");

const businessTypes = [
  "Importer",
  "Exporter",
  "Manufacturer",
  "Commission Agent",
  "Distributor",
  "Wholesaler",
  "Retailer",
  "Other",
];

const CompanyDetails = ({ form, controls }) => {
  const {
    register,
    watch,
    setValue,
    getValues,
    trigger,
    control,
    formState: { errors, isSubmitted },
  } = form;

  const [country, setCountry] = React.useState("");
  React.useEffect(() => {
    ipapi.location((res) => {
      setCountry(res.country_name);
    });
  }, []);

  const [defaultCountryCode, setDefaultCountryCode] = React.useState({});
  React.useEffect(() => {
    if (country) {
      setDefaultCountryCode({ defaultCountry: getCode(country) });
    }
  }, [country, setDefaultCountryCode]);

  const [phoneOverride, setPhoneOverride] = React.useState(false);
  React.useEffect(() => {
    if (phoneOverride) {
      trigger("phone");
    }
  }, [phoneOverride]);

  return (
    <div className="sm:card">
      <div className="text-2xl text-auto-black/80 sm:bg-auto-black/10 sm:p-6 ">
        Company Details
      </div>
      <div className="grid grid-cols-1 gap-4 py-6 sm:px-6 md:grid-cols-2">
        <TextField
          id="fullName"
          label="Full Name"
          autoComplete="name"
          variant="outlined"
          fullWidth // helperText="We'll never share your name."
          required
          {...register("fullName", { required: "Full name is required." })}
          error={!!errors.fullName}
          helperText={errors.fullName?.message}
          component={m.div}
          animate={!!errors.fullName ? controls : {}}
        />
        <TextField
          id="companyName"
          label="Company Name"
          autoComplete="company"
          variant="outlined"
          fullWidth // helperText="We'll never share your name."
          required
          {...register("companyName", {
            required: "Company name is required.",
          })}
          error={!!errors.companyName}
          helperText={errors.companyName?.message}
          component={m.div}
          animate={!!errors.companyName ? controls : {}}
        />
        <TextField
          id="email"
          label="Email"
          // InputProps={{ className: "bg-white" }}
          // InputLabelProps={{
          //   className: "input-label-props",
          // }}
          autoComplete="email"
          variant="outlined"
          fullWidth
          error={!!errors.email}
          required
          {...register("email", {
            required: "Email is required.",
            validate: (value) =>
              validateEmail.validate(value) ||
              "Please enter a valid email address.",
          })}
          helperText={
            errors.email?.message // || "We will never share your email."
          }
          component={m.div}
          animate={!!errors.email ? controls : {}}
          // value={email}
          // onChange={(event) => setEmail(event.target.value)}
        />
        {/* <Controller
          name="phone"
          control={control}
          rules={{
            validate: {
              valid: async (v) =>
                phoneOverride ||
                matchIsValidTel(v) ||
                getValues("phone").length <= `+${countryCallingCode}`.length ||
                "Phone number is invalid. You can click the button in the box to confirm it.",
            },
          }}
          render={({ field, fieldState }) => (
            <MuiTelInput
              {...field}
              id="phone"
              helperText={fieldState.error?.message}
              error={fieldState.invalid}
              label="Phone"
              autoComplete="tel"
              variant="outlined"
              component={m.div}
              animate={!!errors.phone ? controls : {}}
              {...defaultCountryCode}
              MenuProps={{
                sx: { maxHeight: "500px" },
              }}
              // InputLabelProps={{
              //   className: "input-label-props",
              // }}
              onChange={(value, info) => {
                field.onChange(value);
                // console.log(info);
                setCountryCallingCode(info?.countryCallingCode);
                console.log(countryCallingCode);
              }}
              onFocus={() => setPhoneFocused(true)}
              InputProps={{
                // className: "bg-white",
                endAdornment: (
                  <OverridePhoneErrorButton
                    onClick={() => {
                      setPhoneOverride(true);
                      trigger(fieldState.name);
                    }}
                    error={fieldState.invalid}
                  />
                ),
              }}
            />
          )}
        /> */}
        <PhoneInput
          id="phone"
          name="phone"
          label="Phone"
          {...defaultCountryCode}
          control={control}
          rules={{
            // required: "Phone is required.",
            validate: (v) =>
              phoneOverride ||
              v === null ||
              v.length === 0 ||
              isValidPhoneNumber(v) ||
              "Phone number seems to be invalid. You can click the button in the box to confirm it.",
          }}
          international
          showOverride={errors.phone?.type === "validate"}
          phoneOverride={phoneOverride}
          setPhoneOverride={setPhoneOverride}
          // addInternationalOption={false}
          // required
          error={!!errors.phone}
          helperText={errors.phone?.message}
          animate={!!errors.phone ? controls : {}}
        />
        <div>
          <label
            className={`text-start text-sm ${errors.businessType ? "text-red-500" : "text-auto-black/60"}`}
            htmlFor="businessType"
          >
            Business Type
          </label>
          <Controller
            name="businessType"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <Listbox
                  {...field}
                  as={"div"}
                  id="businessType"
                  multiple
                  className={`relative text-start ${errors.businessType ? "text-red-500" : "text-auto-black/60"}`}
                >
                  <Listbox.Button
                    className={`${defaultClasses} relative flex place-items-center gap-1 overflow-hidden !px-2`}
                  >
                    {watch("businessType").map((bt) => (
                      <div
                        key={bt}
                        className="rounded-full bg-secondary px-2 py-1 text-xs text-white"
                      >
                        {bt}
                      </div>
                    ))}
                    <ChevronDownIcon className="absolute inset-y-0 right-2 h-5 w-5 self-center" />
                  </Listbox.Button>
                  <Transition
                    as={React.Fragment}
                    leave="transition ease-in duration-100 origin-top"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Listbox.Options
                      as="div"
                      className="absolute z-10 mt-1 max-h-48 w-full overflow-auto rounded bg-auto-white p-1 text-base shadow ring-1 ring-black/5 focus:outline-none sm:text-sm"
                    >
                      {businessTypes.map((bt) => (
                        <Listbox.Option
                          as="div"
                          id={bt}
                          key={bt}
                          value={bt}
                          className="flex w-full cursor-pointer items-center gap-2 self-stretch rounded p-2 ui-selected:bg-secondary-500/10 ui-selected:font-bold ui-active:bg-primary/20 ui-active:text-primary-900"
                        >
                          <CheckIcon className="invisible h-5 w-5 text-primary-500 ui-selected:visible" />
                          {bt}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </Listbox>
              );
            }}
          />
        </div>
        <Controller
          name="areaOfOperation"
          control={control}
          render={({ field, fieldState }) => {
            return (
              <MultiCountryField
                {...field}
                label="Area of Operation"
                // country={watch("areaOfOperation") || []}
                // setCountry={setValue("areaOfOperation")}
                // {...register("areaOfOperation")}
                error={!!errors.areaOfOperation}
                helperText={errors.areaOfOperation?.message}
                animate={!!errors.areaOfOperation ? controls : {}}
              />
            );
          }}
        />
        {/* <Controller
          name="incoterm"
          control={control}
          rules={{
            validate: (value) => value !== null || "Incoterm is required.",
          }}
          render={({ field, fieldState, fieldState: { error } }) => {
            return (
              <FormControl
                component={m.div}
                animate={!!error ? controls : {}}
                error={!!error}
              >
                <FormLabel
                  id="incoterms-label"
                  // error={!!error ? true : false}
                  required
                >
                  Incoterm
                </FormLabel>
                <ToggleButtonGroup
                  {...field}
                  labelId="incoterms-label"
                  id="incoterm"
                  exclusive
                  // value={watch("incoterm")}
                  onChange={(e, value) => {
                    setValue(field.name, value);
                    isSubmitted && trigger(fieldState.name);
                  }}
                  aria-label="Incoterm"
                  fullWidth
                  variant="outlined"
                  size="large"
                  color={!!error ? "error" : "secondary"}
                  component={m.div}
                  animate={!!error ? controls : {}}
                >
                  <ToggleButton value="EXW">EXW</ToggleButton>
                  <ToggleButton value="FCA">FCA</ToggleButton>
                  <ToggleButton value="FOB">FOB</ToggleButton>
                  <ToggleButton value="CFR">CFR</ToggleButton>
                  <ToggleButton value="CIF">CIF</ToggleButton>
                  <ToggleButton value="DDP">DDP</ToggleButton>
                </ToggleButtonGroup>
                {!!error && <FormHelperText>{error?.message}</FormHelperText>}
              </FormControl>
            );
          }}
        /> */}
        <m.div animate={!!errors.incoterm ? controls : {}}>
          <label
            className={`text-start text-sm ${errors.incoterm ? "text-red-500" : "text-auto-black/60"}`}
            htmlFor="incoterm"
          >
            Incoterm
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="incoterm"
            control={control}
            rules={{
              required: "Incoterm is required.",
            }}
            render={({ field, fieldState }) => {
              return (
                <>
                  <RadioGroup
                    {...field}
                    as={"div"}
                    id="incoterm"
                    className={`${defaultClasses} grid grid-cols-6 divide-x divide-auto-black/30 overflow-hidden !px-0 !py-0 ${fieldState.error ? "border-red-500 text-red-500" : "text-auto-black/60"}`}
                    aria-label="Incoterm"
                  >
                    {["EXW", "FCA", "FOB", "CFR", "CIF", "DDP"].map(
                      (option) => (
                        <>
                          <RadioGroup.Option
                            value={option}
                            key={option}
                            className="flex grow cursor-pointer items-center justify-center text-center text-auto-black/50 hover:bg-primary/20 ui-checked:bg-secondary-500/20 ui-checked:text-secondary-500/80"
                          >
                            <div>{option}</div>
                          </RadioGroup.Option>
                        </>
                      ),
                    )}
                  </RadioGroup>
                  {fieldState.error && (
                    <div className="text-xs text-red-500">
                      {fieldState.error?.message}
                    </div>
                  )}
                </>
              );
            }}
          />
        </m.div>
        <TextField
          id="port"
          label={(() => {
            if (watch("incoterm") === "CFR" || watch("incoterm") === "CIF") {
              return "Destination Port";
            }
            if (watch("incoterm") === "DDP") {
              return "Delivery Address";
            }
            return "Port";
          })()}
          disabled={!["CFR", "CIF", "DDP"].includes(watch("incoterm"))}
          autoComplete="name"
          variant="outlined"
          fullWidth // helperText="We'll never share your name."
          // required if incoterm is CFR or CIF or DDP
          required={(() => {
            if (["CFR", "CIF", "DDP"].includes(watch("incoterm"))) {
              return true;
            }
            return false;
          })()}
          {...register("port", {
            validate: (value, formValues) =>
              (["CFR", "CIF", "DDP"].includes(formValues.incoterm) &&
                value.length > 0) ||
              !["CFR", "CIF", "DDP"].includes(formValues.incoterm) ||
              `${
                ["CFR", "CIF"].includes(watch("incoterm"))
                  ? "Destination port"
                  : "Delivery address"
              } is required for this incoterm.`,
          })}
          error={!!errors.port}
          helperText={errors.port?.message}
          component={m.div}
          animate={!!errors.port ? controls : {}}
        />
        <div>
          <label
            className={`text-start text-sm ${errors.orderVolume ? "text-red-500" : "text-auto-black/60"}`}
            htmlFor="orderVolume"
          >
            Estimated Order Volume
          </label>
          <Controller
            name="orderVolume"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <RadioGroup
                  {...field}
                  as={"div"}
                  id="orderVolume"
                  className={`${defaultClasses} grid grid-cols-2 divide-x divide-auto-black/30 overflow-hidden !px-0 !py-0 ${fieldState.error ? "border-red-500 text-red-500" : "text-auto-black/60"}`}
                  aria-label="Estimated Order Volume"
                >
                  {["Few Tons", "Full Container Loads"].map((option) => (
                    <>
                      <RadioGroup.Option
                        value={option}
                        key={option}
                        className="flex grow cursor-pointer items-center justify-center text-center text-auto-black/50 hover:bg-primary/20 ui-checked:bg-secondary-500/20 ui-checked:text-secondary-500/80"
                      >
                        <div>{option}</div>
                      </RadioGroup.Option>
                    </>
                  ))}
                </RadioGroup>
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;
